import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { AdTopBanner, AdInContent, AdBottomBanner } from '../components/AdSense';

const PercentageCalculatorPage = () => {
  const [calc1X, setCalc1X] = useState('');
  const [calc1Y, setCalc1Y] = useState('');
  const [calc1Result, setCalc1Result] = useState(null);

  const [calc2X, setCalc2X] = useState('');
  const [calc2Y, setCalc2Y] = useState('');
  const [calc2Result, setCalc2Result] = useState(null);

  const [calc3X, setCalc3X] = useState('');
  const [calc3Y, setCalc3Y] = useState('');
  const [calc3Result, setCalc3Result] = useState(null);

  const [calc4From, setCalc4From] = useState('');
  const [calc4To, setCalc4To] = useState('');
  const [calc4Result, setCalc4Result] = useState(null);

  const [calc5Val, setCalc5Val] = useState('');
  const [calc5Pct, setCalc5Pct] = useState('');
  const [calc5Result, setCalc5Result] = useState(null);

  const [calc6Val, setCalc6Val] = useState('');
  const [calc6Pct, setCalc6Pct] = useState('');
  const [calc6Result, setCalc6Result] = useState(null);

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Helmet>
        <title>Percentage Calculator - Free Online Percent Calculator | PercentageCalculatorPlus</title>
        <meta name="description" content="Free online percentage calculator. Calculate percentages instantly: find what percent of a number, percentage change, increase/decrease by percent, and more." />
        <meta name="keywords" content="percentage calculator, percent calculator, calculate percentage, percentage change, percent of number, percentage increase, percentage decrease" />
        <link rel="canonical" href="https://percentagecalculatorplus.net/" />
      </Helmet>
      <Header />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <AdTopBanner />
          
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <Link to="/math" className="text-cyan-400 hover:text-cyan-300">Math</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Percentage Calculator</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-6">Percentage Calculator - Free Online Percent Calculator</h1>

          <div className="space-y-6">
            {/* Calculator 1: What is X% of Y? */}
            <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
              <h2 className="text-lg font-semibold text-white mb-4">What is X% of Y?</h2>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-gray-300">What is</span>
                <Input type="number" value={calc1X} onChange={(e) => setCalc1X(e.target.value)}
                  className="w-20 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">% of</span>
                <Input type="number" value={calc1Y} onChange={(e) => setCalc1Y(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">?</span>
                <Button onClick={() => setCalc1Result((parseFloat(calc1X) / 100) * parseFloat(calc1Y))}
                  className="bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
                {calc1Result !== null && <span className="text-green-400 font-bold ml-2">= {calc1Result.toFixed(2)}</span>}
              </div>
            </div>

            {/* Calculator 2: X is what % of Y? */}
            <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
              <h2 className="text-lg font-semibold text-white mb-4">X is what percent of Y?</h2>
              <div className="flex flex-wrap items-center gap-2">
                <Input type="number" value={calc2X} onChange={(e) => setCalc2X(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">is what % of</span>
                <Input type="number" value={calc2Y} onChange={(e) => setCalc2Y(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">?</span>
                <Button onClick={() => setCalc2Result((parseFloat(calc2X) / parseFloat(calc2Y)) * 100)}
                  className="bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
                {calc2Result !== null && <span className="text-green-400 font-bold ml-2">= {calc2Result.toFixed(2)}%</span>}
              </div>
            </div>

            {/* Calculator 3: X is Y% of what? */}
            <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
              <h2 className="text-lg font-semibold text-white mb-4">X is Y% of what?</h2>
              <div className="flex flex-wrap items-center gap-2">
                <Input type="number" value={calc3X} onChange={(e) => setCalc3X(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">is</span>
                <Input type="number" value={calc3Y} onChange={(e) => setCalc3Y(e.target.value)}
                  className="w-20 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">% of what?</span>
                <Button onClick={() => setCalc3Result(parseFloat(calc3X) / (parseFloat(calc3Y) / 100))}
                  className="bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
                {calc3Result !== null && <span className="text-green-400 font-bold ml-2">= {calc3Result.toFixed(2)}</span>}
              </div>
            </div>

            <AdInContent />

            {/* Calculator 4: Percentage Change */}
            <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
              <h2 className="text-lg font-semibold text-white mb-4">Percentage Change</h2>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-gray-300">From</span>
                <Input type="number" value={calc4From} onChange={(e) => setCalc4From(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">to</span>
                <Input type="number" value={calc4To} onChange={(e) => setCalc4To(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <Button onClick={() => {
                  const from = parseFloat(calc4From);
                  const to = parseFloat(calc4To);
                  setCalc4Result(((to - from) / Math.abs(from)) * 100);
                }} className="bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
                {calc4Result !== null && (
                  <span className={`font-bold ml-2 ${calc4Result >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                    = {calc4Result >= 0 ? '+' : ''}{calc4Result.toFixed(2)}%
                  </span>
                )}
              </div>
            </div>

            {/* Calculator 5: Increase by % */}
            <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
              <h2 className="text-lg font-semibold text-white mb-4">Increase X by Y%</h2>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-gray-300">Increase</span>
                <Input type="number" value={calc5Val} onChange={(e) => setCalc5Val(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">by</span>
                <Input type="number" value={calc5Pct} onChange={(e) => setCalc5Pct(e.target.value)}
                  className="w-20 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">%</span>
                <Button onClick={() => setCalc5Result(parseFloat(calc5Val) * (1 + parseFloat(calc5Pct) / 100))}
                  className="bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
                {calc5Result !== null && <span className="text-green-400 font-bold ml-2">= {calc5Result.toFixed(2)}</span>}
              </div>
            </div>

            {/* Calculator 6: Decrease by % */}
            <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
              <h2 className="text-lg font-semibold text-white mb-4">Decrease X by Y%</h2>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-gray-300">Decrease</span>
                <Input type="number" value={calc6Val} onChange={(e) => setCalc6Val(e.target.value)}
                  className="w-24 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">by</span>
                <Input type="number" value={calc6Pct} onChange={(e) => setCalc6Pct(e.target.value)}
                  className="w-20 bg-[#0d0d0d] border-[#2a2a2a] text-white text-center" />
                <span className="text-gray-300">%</span>
                <Button onClick={() => setCalc6Result(parseFloat(calc6Val) * (1 - parseFloat(calc6Pct) / 100))}
                  className="bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
                {calc6Result !== null && <span className="text-red-400 font-bold ml-2">= {calc6Result.toFixed(2)}</span>}
              </div>
            </div>
          </div>

          <div className="mt-10 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Percentage Formulas</h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-4">
                  <h3 className="text-white font-semibold mb-2">Finding a Percentage</h3>
                  <p className="text-gray-400 text-sm font-mono">Result = (Percentage / 100) × Number</p>
                </div>
                <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-4">
                  <h3 className="text-white font-semibold mb-2">Finding What Percent</h3>
                  <p className="text-gray-400 text-sm font-mono">Percentage = (Part / Whole) × 100</p>
                </div>
                <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-4">
                  <h3 className="text-white font-semibold mb-2">Percentage Change</h3>
                  <p className="text-gray-400 text-sm font-mono">Change = ((New - Old) / |Old|) × 100</p>
                </div>
                <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-4">
                  <h3 className="text-white font-semibold mb-2">Finding the Whole</h3>
                  <p className="text-gray-400 text-sm font-mono">Whole = Part / (Percentage / 100)</p>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-10 p-6 bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl">
            <h3 className="text-lg font-semibold text-white mb-4">Math Calculators</h3>
            <div className="flex flex-wrap gap-2">
              {[{ name: 'Scientific', path: '/scientific-calculator' }, { name: 'Fraction', path: '/fraction-calculator' }, { name: 'Triangle', path: '/triangle-calculator' }, { name: 'Standard Deviation', path: '/standard-deviation-calculator' }].map((calc) => (
                <Link key={calc.path} to={calc.path} className="px-3 py-1.5 bg-[#0d0d0d] border border-[#2a2a2a] rounded text-cyan-400 hover:text-cyan-300 text-sm">{calc.name}</Link>
              ))}
            </div>
          </div>
          <AdBottomBanner />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PercentageCalculatorPage;
